import { styled } from '@mui/material';
import classNames from 'classnames';
import { useMemo } from 'react';
import { AudioPlayer } from 'src/components/AudioPlayer';
import { useConversationMessageMediaContentState } from '../../conversation/ConversationMediaContentView/useConversationMessageMediaContent';
import { DownloadContentAudio } from './DownloadContentAudio';
import { IConversationMessageContentProps } from './types';

export function ConversationMessageContentAudio({
  message,
  compact,
  isReply,
}: IConversationMessageContentProps) {
  const { mediaContent } = useConversationMessageMediaContentState();

  const messageMediaContent = useMemo(() => {
    if (!message.mediaRef) return;
    return mediaContent[message.mediaRef];
  }, [message.mediaRef, mediaContent]);

  return (
    <StyledAudioContainer>
      <StyledContainer className={classNames({ compact })}>
        <AudioPlayer src={messageMediaContent?.mediaContent as string} />
      </StyledContainer>
      {!isReply && (
        <DownloadContentAudio
          fileName={message.fileName as string}
          mimeType={message.mimeType as string}
          mediaContent={messageMediaContent?.mediaContent as string}
        />
      )}
    </StyledAudioContainer>
  );
}

const StyledAudioContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1.5),
}));

const StyledContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  borderRadius: theme.shape.borderRadius,
  border: `solid 1px ${theme.palette.divider}`,
  maxWidth: 350,
  width: '100%',
  padding: theme.spacing(1.5),
  gap: theme.spacing(1.5),
  '&.compact': {
    padding: theme.spacing(1),
    gap: theme.spacing(1),
  },
}));
